import { render, staticRenderFns } from "./mail.vue?vue&type=template&id=645da4c4&scoped=true"
import script from "./mail.vue?vue&type=script&lang=js"
export * from "./mail.vue?vue&type=script&lang=js"
import style0 from "./mail.vue?vue&type=style&index=0&id=645da4c4&prod&lang=less&scoped=true"
import style1 from "./mail.vue?vue&type=style&index=1&id=645da4c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645da4c4",
  null
  
)

export default component.exports